import {Box, Paragraph} from 'grommet'
import {FormattedMessage} from 'react-intl'

import LoginButtonGov from '../../components/login/LoginButtonGov'
import CenteredMain from '../../components/layout/CenteredMain'
import ChaveMovelInfo from '../../components/login/ChaveMovelInfo'
import CollectedDataInfo from '../../components/infoButtons/CollectedDataInfo'
import Page from '../../components/layout/Page'
import { useAuth } from '../../components/auth/AuthContext'
import { useEffect } from 'react'
import { useGoToPage } from '../../routeConfig'

function Home() {
  const {isLoggedIn} = useAuth()
  const goToPage = useGoToPage()

  useEffect(() => {
    if (isLoggedIn) {
      goToPage('status')
    }
  }, [isLoggedIn, goToPage])

  return (
    <Page>
      <CenteredMain>
        <ChaveMovelInfo />

        <Box pad={{bottom: 'small', top: 'medium'}} align="center">
          <LoginButtonGov />
          <CollectedDataInfo />
        </Box>

        <Paragraph size="medium" textAlign="center">
          <FormattedMessage id="login.main.cookieInfo" />
        </Paragraph>
      </CenteredMain>
    </Page>
  )
}

export default Home
